import React, { useState, useEffect } from "react";
import "./huntGraph.scss";
import LineChart from "../../../reusableComponents/graph/lineGraph";
import BarChart from "../../../reusableComponents/graph/barGraph";

export default function Slideshow(props) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? props?.GraphData?.length - 1 : prevIndex - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === props?.GraphData?.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="slider-container">
      {props?.GraphData?.length > 0 &&
        <div className="slideshow">
          <h6 style={{ fontSize: 15, color: '#454545', textTransform: 'capitalize' }}>{props?.GraphData[currentIndex].variableName}</h6>
          <div className="graph-slider-container">
            {props.header == 'Bar Graph' &&
              <BarChart rawData={props?.GraphData[currentIndex]}></BarChart>
            }
            {props.header == 'Line Graph' &&
              <LineChart rawData={props?.GraphData[currentIndex]}></LineChart>
            }
          </div>
          <div className="slider-dots-container" style={{
            // bottom: props.header == 'Bar Graph' ? '80px' : '40px'
          }}>
            <button className="slider-button-style right-position" style={{
              // top: props.header == 'Bar Graph' ? '' : '88%'
            }} onClick={goToPrevious}>&#10094;</button>
            <div className="dot-container" style={{ bottom: props.header == 'Bar Graph' ? '' : '-5%' }}>
              {props?.GraphData?.map((item, index) => {
                return (
                  <div onClick={() => { setCurrentIndex(index) }} className={currentIndex == index ? "dots blue" : "dots"} ></div>
                )
              })}
            </div>
            <button className="slider-button-style left-position" style={{
              //  top: props.header == 'Bar Graph' ? '' : '88%'
            }} onClick={goToNext}>&#10095;</button>
          </div>
        </div>
      }
    </div>
  );
}

